<div style="max-height: 650px; overflow-y: scroll">
  <mat-tree
    #loadOnViewTree
    [dataSource]="dataSource"
    [(treeControl)]="treeControl"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    <mat-tree-node
      class="site-tree-node"
      *matTreeNodeDef="let node"
      matTreeNodeToggle
      cdkDrag
      [cdkDragData]="node"
      (mouseenter)="dragHover(node)"
      (mouseleave)="dragHoverEnd()"
      (cdkDragStarted)="dragStart()"
      (cdkDragReleased)="dragEnd()"
      matTreeNodePadding
      (click)="activeNode = node"
    >
      <div class="row" style="width: 100%">
        <div class="col-md-8">
          <button
            type="button"
            bciprimarybutton
            (click)="$event.preventDefault()"
            disabled
            style="border: none"
          ></button>
          <mat-label (click)="featureLeafItemSelectionToggle(node)">{{
            node.title
          }}</mat-label>
        </div>
        <div class="col-md-4" style="text-align: right">
          <button
            bciprimarybutton
            class="button-primary"
            (click)="editNode(node, treeType.LOAD_ON_TREE)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="edit icon"
                class="bosch-ic-edit"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
          &nbsp;
          <button
            type="button"
            bciprimarybutton
            class="button-primary"
            (click)="newSubItem(node, treeType.LOAD_ON_TREE)"
            [disabled]="node.nodeType === 'LOAD'"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
          &nbsp;
          <button
            bciprimarybutton
            class="button-primary"
            (click)="removeNodeItem(node, treeType.LOAD_ON_TREE)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-abort-frame"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
        </div>
      </div>
    </mat-tree-node>

    <mat-tree-node
      class="site-tree-node"
      *matTreeNodeDef="let node; when: hasChild"
      cdkDrag
      [cdkDragData]="node"
      (mouseenter)="dragHover(node)"
      (mouseleave)="dragHoverEnd()"
      (cdkDragStarted)="dragStart()"
      (cdkDragReleased)="dragEnd()"
      matTreeNodePadding
      (click)="activeNode = node"
    >
      <div class="row" style="width: 100%">
        <div class="col-md-7">
          <button
            type="button"
            bciprimarybutton
            (click)="$event.preventDefault()"
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.filename"
            style="border: none"
          >
            <mat-icon
              *ngIf="treeControl.isExpanded(node)"
              fontIcon="Bosch-Ic-arrow-expand-down"
            ></mat-icon>
            <mat-icon
              *ngIf="!treeControl.isExpanded(node)"
              fontIcon="Bosch-Ic-arrow-expand-right"
            ></mat-icon>
          </button>
          <mat-label>{{ node.title }}</mat-label>
        </div>
        <div class="col-md-5" style="text-align: right">
          <button
            bciprimarybutton
            class="button-primary"
            (click)="editNode(node, treeType.LOAD_ON_TREE)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="edit icon"
                class="bosch-ic-edit"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
          &nbsp;
          <button
            type="button"
            bciprimarybutton
            class="button-primary"
            (click)="newSubItem(node, treeType.LOAD_ON_TREE)"
            [disabled]="node.nodeType === 'LOAD'"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="add icon"
                class="bosch-ic-add"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
          &nbsp;

          <button
            bciprimarybutton
            class="button-primary"
            (click)="removeNodeItem(node, treeType.LOAD_ON_TREE)"
          >
            <span>
              <mat-icon
                aria-hidden="false"
                aria-label="weather icon"
                class="bosch-ic-abort-frame"
                style="width: max-content"
              ></mat-icon>
            </span>
          </button>
        </div>
      </div>
    </mat-tree-node>
  </mat-tree>
</div>
